import { gql } from "@apollo/client";

export const GET_INSTITUCIONES = gql`
query QGetInstituciones{
    instituciones(origen: "") {
        success,
        error,
        valorEsperado {
          cod_Institucion,
          nombre,
          idDelegacion,
          delegacion,
          origen,
          nombreFantasia,
          domicilio,
          activo,
          tipoUnidad,
          idLocalidad,
          idProvincia,
          localidad,
          tipoInstitucion
        }
    }
}`;